export const CONTRACT_STATUS_ALL = "all";

export const CONTRACT_STATUS_OPTIONS = [
  { value: CONTRACT_STATUS_ALL, label: "All statuses" },
  { value: "approved", label: "Approved" },
  { value: "under_review", label: "Under Review" },
  { value: "draft", label: "Draft" }
] as const;

export const CONTRACT_DATE_RANGE_OPTIONS = [
  { value: 30, label: "Last 30 Days" },
  { value: 15, label: "Last 15 Days" },
  { value: 10, label: "Last 10 Days" }
] as const;

export type ContractDateRangeValue = (typeof CONTRACT_DATE_RANGE_OPTIONS)[number]["value"];

export const REVIEW_CLIENT_LABEL = "Client Name";
